/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateDevice200Response
 */
export interface UpdateDevice200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateDevice200Response
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDevice200Response
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDevice200Response
     */
    platform: UpdateDevice200ResponsePlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateDevice200Response
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDevice200Response
     */
    osVersion: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDevice200Response
     */
    appVersion: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDevice200Response
     */
    webviewVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDevice200Response
     */
    nativeVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDevice200Response
     */
    mode: UpdateDevice200ResponseModeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDevice200Response
     */
    isDataphone: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateDevice200Response
     */
    preferredCashMachine: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDevice200Response
     */
    preferredDataphone: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDevice200Response
     */
    preferredTill: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDevice200Response
     */
    useSelfPrinter: boolean | null;
}


/**
 * @export
 */
export const UpdateDevice200ResponsePlatformEnum = {
    Ios: 'ios',
    Android: 'android',
    Electron: 'electron',
    Web: 'web'
} as const;
export type UpdateDevice200ResponsePlatformEnum = typeof UpdateDevice200ResponsePlatformEnum[keyof typeof UpdateDevice200ResponsePlatformEnum];

/**
 * @export
 */
export const UpdateDevice200ResponseModeEnum = {
    Master: 'master',
    Slave: 'slave'
} as const;
export type UpdateDevice200ResponseModeEnum = typeof UpdateDevice200ResponseModeEnum[keyof typeof UpdateDevice200ResponseModeEnum];


/**
 * Check if a given object implements the UpdateDevice200Response interface.
 */
export function instanceOfUpdateDevice200Response(value: object): value is UpdateDevice200Response {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('platform' in value) || value['platform'] === undefined) return false;
    if (!('model' in value) || value['model'] === undefined) return false;
    if (!('osVersion' in value) || value['osVersion'] === undefined) return false;
    if (!('appVersion' in value) || value['appVersion'] === undefined) return false;
    if (!('mode' in value) || value['mode'] === undefined) return false;
    if (!('isDataphone' in value) || value['isDataphone'] === undefined) return false;
    if (!('preferredCashMachine' in value) || value['preferredCashMachine'] === undefined) return false;
    if (!('preferredDataphone' in value) || value['preferredDataphone'] === undefined) return false;
    if (!('preferredTill' in value) || value['preferredTill'] === undefined) return false;
    if (!('useSelfPrinter' in value) || value['useSelfPrinter'] === undefined) return false;
    return true;
}

export function UpdateDevice200ResponseFromJSON(json: any): UpdateDevice200Response {
    return UpdateDevice200ResponseFromJSONTyped(json, false);
}

export function UpdateDevice200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDevice200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'platform': json['platform'],
        'model': json['model'],
        'osVersion': json['osVersion'],
        'appVersion': json['appVersion'],
        'webviewVersion': json['webviewVersion'] == null ? undefined : json['webviewVersion'],
        'nativeVersion': json['nativeVersion'] == null ? undefined : json['nativeVersion'],
        'mode': json['mode'],
        'isDataphone': json['isDataphone'],
        'preferredCashMachine': json['preferredCashMachine'],
        'preferredDataphone': json['preferredDataphone'],
        'preferredTill': json['preferredTill'],
        'useSelfPrinter': json['useSelfPrinter'],
    };
}

export function UpdateDevice200ResponseToJSON(json: any): UpdateDevice200Response {
    return UpdateDevice200ResponseToJSONTyped(json, false);
}

export function UpdateDevice200ResponseToJSONTyped(value?: UpdateDevice200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'platform': value['platform'],
        'model': value['model'],
        'osVersion': value['osVersion'],
        'appVersion': value['appVersion'],
        'webviewVersion': value['webviewVersion'],
        'nativeVersion': value['nativeVersion'],
        'mode': value['mode'],
        'isDataphone': value['isDataphone'],
        'preferredCashMachine': value['preferredCashMachine'],
        'preferredDataphone': value['preferredDataphone'],
        'preferredTill': value['preferredTill'],
        'useSelfPrinter': value['useSelfPrinter'],
    };
}

